import { useLazyGetAgentListAgentListGetQuery } from '@shared/api';

export const useGetAgentsLazy = () => {
  const [fetchAgents, { data, isLoading, isFetching, isError }] =
    useLazyGetAgentListAgentListGetQuery();

  const isEmpty = !data || data.length === 0;
  const count = data?.length ?? 0;

  return {
    fetchAgents,
    agents: data,
    count,
    isEmpty,
    isLoading,
    isFetching,
    isError,
  };
};
